import classNames from 'classnames';
import React from 'react';

import Spinner from 'ui-library/Spinner';

export interface ComputingTagSchemaConstraintProps {
  className?: string;
}

function ComputingTagSchemaConstraint({className}: ComputingTagSchemaConstraintProps): JSX.Element | null {
  return (
    <div className="simpleDivTable-row">
      <div className={classNames(className, 'simpleDivTable-cell')}>
        <Spinner classNames="u-valign-middle" light={true} />
        <span className="u-mini-spacing-left u-valign-middle">
          Creating this constraint might take a moment. Try refreshing after a few minutes.{' '}
        </span>{' '}
      </div>
    </div>
  );
}

export default ComputingTagSchemaConstraint;
